<template>
  <div id="app" class="app">
    <router-view />
    <Scanner />
  </div>
</template>

<script>
import Scanner from '@/components/Scanner'

export default {
  components: { Scanner }
}
</script>

<style lang="scss">
@import '@/scss/variables';

* {
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

html,
body {
  margin: 0;
  height: 100%;
}

.app {
  height: 100%;

  background: $main;

  font-family: $font-family;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.view {
  display: flex;
  flex-direction: column;
  height: 100%;

  background: #fff;
}

.headline {
  margin: 2rem 1rem 1rem;
}

.header {
  flex-shrink: 0;
}

.content {
  flex-grow: 1;
  overflow-y: scroll;

  &__inner {
    margin: 0 auto;
    padding: 1rem;
    max-width: 50rem;
    width: 100%;
  }
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
</style>
